export enum TransportationTypeEnum {
    WALKING = 'WALKING',
    CYCLING = 'CYCLING',
    CAR = 'CAR',
    BUS = 'BUS',
    TRAIN = 'TRAIN'    
}